<template>
    <!--  @71178 - Aba para editar ou cadastrar um assunto de uma agrovisita -->
    <div>
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />

        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="permissaoCadastrar && !assuntoagrovisitaIntegracao"
                    @click="saveAssuntoRtr"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t("salvar") }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <!-- FORMULÁRIO -->
        <div class="page-container form-columns-fit">
            <div class="columns pb-3">
                <div class="column is-2">
                    <v-input
                        :id="'codigo'"
                        ref="idassuntortrerpInput"
                        v-model="assuntortr.idassuntortrerp"
                        placeholder="placeholder-preencha"
                        :maxlength="30"
                        title="codigo"
                        uppercase
                        :required="isUpdate"
                        :invalid="isUpdate && isNull(assuntortr.idassuntortrerp)"    
                        :tooltipLabel="isUpdate ? 'regra-prefixo-GA-edicao' : 'regra-prefixo-GA-criacao'"
                    />
                </div>
                <div class="column">
                    <v-input
                        v-model="assuntortr.descricao"
                        ref="descricaoInput"
                        id="descricao"
                        placeholder="descricao-do-assunto-agro-visita-placeholder"
                        title="descricao"
                        msg="msg-campo-obrigatorio"
                        :maxlength="100"
                        :invalid="!assuntortr.descricao"
                        uppercase
                        required
                        :tooltipLabel="'informacao-descricao-assunto-agro-visita'"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            (isUpdate && !permissao.update) ||
                            (!isUpdate && !permissao.create)
                        "
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AssuntoRtrService from "@/services/agro/AssuntoRtrService";
import AssuntoRtrValidation from "@/services/validations/AssuntoRtrValidation";
import Message from "@/models/Message";

export default {
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        "assuntortr.descricao": function (new_) {
            this.$emit("onDescricaoChange", new_);
        },
    },
    data() {
        return {
            assuntoagrovisitaIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("ASSUNTORTR"),
            integracao: this.$store.state.user.tabelasERPWebServer.includes(
                "AGRO_ASSTIPOVISITAASSUNTOVISITA"
            ),
            service: new AssuntoRtrService(this.$http, this.$router),
            validation: new AssuntoRtrValidation(this.$root.msgs),
            isSaving: false,
            assuntortr: {
                idassuntortrerp: null,
                descricao: null,
            },
            title: "",
            msgs: [],
            isLoading: false,
            permissao: false,
            abrev: this.$route.meta.contexto.slice(0,3),
            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",
            originalIdErp: ''
        };
    },
    created() {
        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0,4);
            this.permissao = this.hasPermissionAccess(
                "agro",
                "agro-cadastros",
                "agro-assunto-agrovisita"
            );
        }else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "crm",
                "ven-assunto-agrovisita"
            );
        }

        if (this.$route.params.id) {
            this.isUpdate = true;
        }

        this.permissaoCadastrar =
            ((this.permissao.update && this.isUpdate) ||
                (this.permissao.create && !this.isUpdate)) &&
            !this.integracao;

        if (
            (!this.isUpdate && !this.permissao.create) ||
            (this.isUpdate && !this.permissao.read)
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "assuntos-agro-visita" },
            });
        } else {
            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
            }
        }
    },
    methods: {
        carregarDados(id) {
            this.service.find(id, this.abrev).then((body) => {
                if (body.content) {
                    this.assuntortr = body.content;
                    this.title = this.assuntortr.descricao;
                    this.originalIdErp = this.assuntortr.idassuntortrerp;
                } else {
                    this.$router.push({ name: `${this.abrev}-assunto-agrovisita-new` });
                }
            });
        },
        saveAssuntoRtr() {
            this.isLoading = true;
            this.assuntortr = this.mapTosave(this.assuntortr);

            if (this.validation.validate(this.assuntortr, this.$refs)) {
                if(this.isPrefixSovisInIdErpInvalid(this.assuntortr.idassuntortrerp || '', this.originalIdErp)) {
                    const message = 
                        this.isUpdate ? 'nao-permitido-prefixo-ga-alterar' : 'nao-permitido-prefixo-ga-no-campo-codigo';
            
                    this.isLoading = false;

                    return this.$root.showMessage('alert', message, true);
                }

                this.isSaving = true;

                this.service.save(this.assuntortr, this.abrev)
                    .then((body) => {
                        let msg = "msg-assuntoagro-visita-salva";

                        if (this.assuntortr.id) {
                            msg = "msg-assuntoagro-visita-edita";
                        }

                        this.assuntortr = body.content;
                        this.$root.showMessage("success", msg);
                        this.redirectToPage();
                    })
                    .catch((e) => {
                        if (this.$te(e.body.message)) {
                            if (e.body.message == "msg-codigo-duplicado-n") {
                                this.msgs.push(
                                    new Message(
                                        "alert", 
                                        this.$t(e.body.message, { n: this.assuntortr.idassuntortrerp }), 
                                        true, 
                                        false
                                    )
                                );
                            } else {
                                this.msgs.push(
                                    new Message("alert", e.body.message, true)
                                );
                            }
                        } else {
                            if (e.body.message) {
                                this.$root.showMessage("error", e.body.message);
                            } else {
                                this.$root.showMessage(
                                    "error",
                                    "msg-problema-realizar-acao"
                                );
                            }
                        }
                    })
                    .finally((_) => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.isSaving = false;
                this.isLoading = false;
                this.msgs.push(
                    new Message("alert", "msg-campos-obrigatorios", true)
                );
            }
        },
        redirectToPage() {
            this.$router.push({
                name: `${this.abrev}-assunto-agrovisita-edit`,
                params: { id: this.assuntortr.id, descricao: this.assuntortr.descricao },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
}
</style>